export default "__VITE_PUBLIC_ASSET__ead94992__"